import iphoneApp from '../../../public/webp/fromPNG/portfolio/iphone-app.webp';
import iphoneScreens from '../../../public/webp/fromPNG/portfolio/iphone-screens.webp';
import panenkaClub from '../../../public/webp/fromPNG/portfolio/panenka-club.webp';
import panenkaDashboard from '../../../public/webp/fromPNG/portfolio/panenka-dashboard.webp';
import panenkaPlayer from '../../../public/webp/fromPNG/portfolio/panenka-player.webp';
import panenkaSquad from '../../../public/webp/fromPNG/portfolio/panenka-squad.webp';
// import turntableLayout from '../../../public/png/portfolio/turntable-layout.png';
import turntableStage from '../../../public/webp/fromPNG/portfolio/turntable-stage.webp';
import colorPalette from '../../../public/webp/portfolio/color-palette.webp';
import turntableDashboard from '../../../public/webp/portfolio/turntable-dashboard.webp';

export const portfolioData = {
  mainText: `Here's a glimpse of our creative work`,
  description: `Our designers excel at crafting visually stunning and user-friendly products.`,
  examples: [
    {
      img: panenkaClub,
      alt: 'football-club-overview',
    },
    {
      img: panenkaSquad,
      alt: 'squad-view',
    },
    {
      img: panenkaPlayer,
      alt: 'football-player-details',
    },
    {
      img: panenkaDashboard,
      alt: 'panenka-app-dashboard',
    },
    {
      img: colorPalette,
      alt: 'matching-colors-palette-for-design',
      isVertical: true,
    },
    {
      img: turntableDashboard,
      alt: 'turntable-app-dashboard',
    },
    {
      img: turntableStage,
      alt: 'live-concert-stage-with-equipment',
    },
    // {
    //   img: turntableLayout,
    //   alt: 'turntable-app-on-laptop-screen',
    // },
    {
      img: iphoneApp,
      alt: 'mobile app interface',
    },
    {
      img: iphoneScreens,
      alt: 'side-by-side mobile app screens',
    },
  ],
};
